import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { CURRENT_BOOKING } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  const booking = bffResponse?.currentBooking?.booking;
  // profile/full answers 200 with currentBooking: null when the token doesn't resolve (expired
  // or invalid ?token= deep link). GraphQL errored there; without this, FormReservation's
  // onCompleted destructures the missing section and the user gets no banner at all.
  if (!booking) {
    const error = new Error('The booking token did not resolve to a current booking');
    error.graphQLErrors = [
      { message: error.message, extensions: { code: 'CURRENT_BOOKING_NOT_FOUND' } },
    ];
    error.networkError = null;
    throw error;
  }
  return { currentBooking: booking };
}

export default function useCurrentBooking(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(CURRENT_BOOKING, options);
  const [restExecute, restState] = useAsyncCall(
    () => restRequest({ path: '/air-api/v1/profile/full' }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
